class ContentCarousel extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.mobileCarouselStyle === "multi") return;

    this.id = this.dataset.id;
    this.swiperEl = this.querySelector(".swiper");
    this.slides = this.querySelectorAll(".swiper-slide");

    if (this.swiperEl.classList.contains("swiper-initialized")) {
      this.updatePaginationPosition();
    } else {
      this.addEventListener("swiper:init", this.handleSwiperEvent.bind(this));
    }
    this.addEventListener("swiper:change", this.handleSwiperEvent.bind(this));
  }

  handleSwiperEvent({ detail }) {
    if (detail.id !== this.id) return;
    this.updatePaginationPosition(detail.activeIndex);
  }

  updatePaginationPosition(currentIndex = 0) {
    const currentSlide = this.slides[currentIndex];
    const slideImage = currentSlide.querySelector("img");

    if (!slideImage) return;

    this.style.setProperty(
      "--pagination-spacer-aspect-ratio",
      slideImage.dataset.aspectRatio,
    );
  }
}

if (!customElements.get("section-content-carousel")) {
  customElements.define("section-content-carousel", ContentCarousel);
}
